import { render, staticRenderFns } from "./UHF-DVS-25.vue?vue&type=template&id=d6107306&lang=pug"
import script from "./UHF-DVS-25.vue?vue&type=script&lang=js"
export * from "./UHF-DVS-25.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports